import gql from "graphql-tag";
import { authTypeDef } from "../definitions/auth-type-def";
import { errorsTypeDef } from "../../errors/errors-type-def";

const authorizeMutation = gql`
  mutation authorizePartnerUser($username: String!, $password: String!) {
    auth {
      authorizePartnerUser(input: {
        username: $username
        password: $password
      }) {
        output {
          ${authTypeDef}
        }
        errors {
          ${errorsTypeDef}
        }
      }
    }
  }`;

export default authorizeMutation;
